import Chartist from 'chartist'

export function getData (dataset) {
  

  //let arr = []

  //dataset.forEach((e)=> {
    //arr.push (1) 
  //}) 
  //let arr2 = []

  //dataset.forEach((e)=> {
    //arr2.push (0.5) 
  //}) 

  const data = {
    labels: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ],
    //series: [ arr, arr2, dataset ],
    series: [dataset],
  }

  return data
}

export function getAverageData (dataset) {
  const data = {
    labels: [ "Jan","Feb","Mrz","Apr", "Mai", "Jun", "Jul","Aug","Sep","Okt","Nov","Dez"],
    series: [ dataset ],
  }

  return data
}

export function getOptions (suggestedMax, suggestedMin) {

  const options = {
    seriesBarDistance: 100,
    low: suggestedMin < 0 ? suggestedMin - 1 : 0,
    height: '100%',
    stackBars: false,
    axisX: {
      // On the x-axis start means top and end means bottom
      position: 'end',
      onlyInteger: true,
      showGrid: false,
    },
    axisY: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    chartPadding: {
      top: 20
    },
    plugins: [
      Chartist.plugins.tooltip(),
      Chartist.plugins.ctBarLabels(),
      Chartist.plugins.animateBars(),
      Chartist.plugins.emptyDataset(),
      Chartist.plugins.preventResize()
    ],

  }

  return options
}

export function getAverageOptions (suggestedMax, suggestedMin) {
  const options = {
    seriesBarDistance: 100,
    high: suggestedMax + 0.2,
    low: suggestedMin < 0 ? suggestedMin - 1 : 0,
    height: '100%',
    axisX: {
      // On the x-axis start means top and end means bottom
      position: 'end',
      onlyInteger: true,
      showGrid: false,
    },
    axisY: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    chartPadding: {
      top: 20,
    },
    plugins: [
      Chartist.plugins.ctBarLabels(),
      Chartist.plugins.animateBars(),
      Chartist.plugins.emptyDataset(),
      Chartist.plugins.preventResize(),
    ],

  }

  return options
}

export function getResponsiveOptions () {
  const responsiveOptions = [
    [ 'screen and (min-width: 768px)', {
      seriesBarDistance: 10,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value
        },
      },
    } ],
    [ 'screen and (max-width: 640px)', {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value
        },
      },
    } ],
  ]

  return responsiveOptions
}
